module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_PT-cf94070968fe7978afea8913b3bbeb53.svg";